module.exports = __webpack_public_path__ + "img/battery-quarter.d6471a0a.svg";